import PropTypes from 'prop-types';
/**
 * This is a custom wrapper for React PropType Validators following the interface
 * of Breakpoint<T>
 *
 * @param {Requireable<T>} propType
 * @returns
 */
export function responsivePropTypes(propType) {
    return PropTypes.shape({
        xs: propType,
        s: propType,
        m: propType,
        l: propType,
        xl: propType,
        xxl: propType,
    });
}
//# sourceMappingURL=propTypes.js.map